import {getCookie} from 'methods/utils';

/**
 * Объект для работы с незарегистрированным пользователем
 */
function UnauthorizedUser() {
    if (!this._hasCookie()) {
        this.registration();
    }
}

/**
 * Проверяем что есть кука
 * @return {bool} true если есть кука, иначе false
 */
UnauthorizedUser.prototype._hasCookie = function() {
    return !!document.cookie.match(/unauthorized_user(\d+)/);
}

/**
 * Регистрируем пользователя
 * @return {Promise}
 */
UnauthorizedUser.prototype.registration = function() {
    if (this._hasCookie()) {
        return Promise.reject('Пользователь уже зарегистрирован');
    }

    return fetch('/unauthorized_users/registration/', {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
    .then(response => response.json())
    .then(r => {
        return r.status === 'ok';
    });
}


/**
 * Данные пользователя
 * @return {Object} объект с полями или пустой объект
 */
UnauthorizedUser.prototype.getUser = function() {
    if (!this._hasCookie()) {
        return {};
    }

    let match = document.cookie.match(/unauthorized_user(\d+)/);

    return {
        user_id: match[1],
        token: getCookie(match[0]),
    }
}

export default UnauthorizedUser;